export default __webpack_public_path__ + "static/media/user-down-arrow.5824fcd1.svg";